module.exports = __webpack_public_path__ + "static/media/sequenceInsight.3aac9178.png";